module.exports = __webpack_public_path__ + "static/img/researchbg.6ae98c96.jpg";